<script>
    import { Card, CardImg, Spinner } from 'sveltestrap'
    
    export let geopoint
    
    let loading = true
    let token = 'pk.eyJ1IjoiaW1wYWN0bWVkaWFpbnQiLCJhIjoiY2p3dDA0aGt2MDczcjN6azF2cHgyOTJpdSJ9.YueIhbBnNUGikXN5ANfA5g'
    let src = '/images/location.png'

    $: if (!!geopoint) {
        let [lat, long] = geopoint.split(',')
        src = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${long},${lat},16.67,0.00,0.00/1000x600@2x?access_token=${token}`
        loading = false
    }

</script>

<Card body>
    <CardImg {src} alt="" />
</Card>